import { Paper } from "@components/paper";
import StartForm from "./StartForm";
import React from "react";
import { withLoanForm } from "../withLoanForm";
import ContentWrapper from "@components/contentWrapper/contentWrapper";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";

const _StartFormWrap = props => {
  const {...rest} = props;
  return (
    <Paper $padding={0}>
      <ContentWrapper paddingTop="0">
        <MarginLeftRow>
          <PaddingLeftCol>
            <StartForm {...rest} />
          </PaddingLeftCol>
        </MarginLeftRow>
      </ContentWrapper>
    </Paper>
  );
};

export const StartFormWrap = withLoanForm(_StartFormWrap);
export default StartFormWrap;